// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__18IyV","content":"GlobalSearch_content__3XcR1"};